
document.addEventListener('DOMContentLoaded', function () {
    const el = document.querySelector('.facets-vertical-sort.footer-filter-disabled');
    if (el) {
        el.classList.remove('footer-filter-disabled');
    }
      const read_more = document.getElementById('read-more');
      const read_less = document.getElementById('read-less');
      const truncated_description = document.getElementById('truncated-product-description');
      const full_description = document.getElementById('product-description');

      // Add event only if button exists
      if (read_more) {
        read_more.addEventListener('click', showHideDescription);
      }

      if (read_less) {
        read_less.addEventListener('click', showHideDescription);
      }

      function showHideDescription() {
        // Safety check
        if (!truncated_description || !full_description) return;

        if (this.id === "read-more") {
          truncated_description.style.display = "none";
          full_description.style.display = "block";
        } else if (this.id === "read-less") {
          truncated_description.style.display = "block";
          full_description.style.display = "none";
        }
      }
const desc = document.getElementById("collection-description");
  const toggle = document.getElementById("toggle-description");

  if (desc && toggle) {
    toggle.addEventListener("click", function () {
      if (desc.classList.contains("description-short")) {
        desc.classList.remove("description-short");
        desc.classList.add("description-full");
        toggle.textContent = "Read less";
      } else {
        desc.classList.remove("description-full");
        desc.classList.add("description-short");
        toggle.textContent = "Read more";
      }
    });
  }
});

document.addEventListener('click', function (e) {
    const isFilterEvent = e.target.closest('.js-filter-event');

    if (isFilterEvent) {
        document.body.classList.add('filter-active');
        document.documentElement.classList.add('filter-active');

        const filterWrapper = document.querySelector('.facets-vertical-sort');
        if (filterWrapper) {
            filterWrapper.classList.add('footer-filter-disabled');
        }

        document.querySelectorAll('.mobile-facets__disclosure').forEach(function (el) {
            el.classList.add('menu-opening');
            el.setAttribute('open', true);
        });


        const detailsElements = document.querySelectorAll('.mobile-facets__details');
        if (detailsElements.length > 0) {
            console.log('clicked>>>>>menu')
            const first = detailsElements[0];
            first.classList.add('menu-opening');
            first.setAttribute('open', '');
        }
    }
});

// Separate event listener for handling mobile facet toggles
const allDetails = document.querySelectorAll('.mobile-facets__details');

allDetails.forEach(details => {
  const summary = details.querySelector('summary');
  if (!summary) return;

  details.addEventListener('toggle', () => {
    const isMobile = window.innerWidth < 750;
    const isOpen = details.open;

    // Update aria
    summary.setAttribute('aria-expanded', String(isOpen));
    details.classList.toggle('menu-opening', isOpen);

    if (!isMobile || !isOpen) return;

    // Close others on mobile when one opens
    allDetails.forEach(other => {
      if (other !== details) {
        other.open = false;
        other.classList.remove('menu-opening');
        const otherSummary = other.querySelector('summary');
        if (otherSummary) otherSummary.setAttribute('aria-expanded', 'false');
      }
    });
  });
});



document.addEventListener('click', function (e) {
    if (e.target.classList.contains('js-drawer-close')) {
        document.body.classList.remove('filter-active');
        document.documentElement.classList.remove('filter-active');

        const ffilterWrapper = document.querySelector('.vertical-filter__main-wrapper');
        if (ffilterWrapper) {
            ffilterWrapper.classList.remove('footer-filter-disabled');
        }

        document.querySelectorAll('.mobile-facets__disclosure').forEach(function (el) {
            el.classList.remove('menu-opening');
            el.removeAttribute('open');
        });
    }
});

function setCardBannerHeight() {
  const li = document.querySelector(".product-grid-container ul li .card-wrapper");
  const banners = document.querySelectorAll('#product-grid .card-banner');

  if (!li || !banners.length) return;

  const height = li.offsetHeight;
  console.log(height);
  banners.forEach(banner => {
    banner.style.height = `${height}px`;
  });

  console.log("Banner height set to:", height);
}

// Run once after page load
window.addEventListener('load', setCardBannerHeight);

// Recalculate on window resize
window.addEventListener('resize', setCardBannerHeight);

// Optional: if products reload dynamically (e.g. via AJAX)
const grid = document.querySelector('#product-grid');
if (grid) {
  const observer = new MutationObserver(setCardBannerHeight);
  observer.observe(grid, { childList: true, subtree: true });
}
function equalHeightCards_collection() { 
  const cards = document.querySelectorAll('.prd_card-content .card__information'); 
  let maxHeight = 0;  cards.forEach(card => { 
    card.style.height = 'auto'; }); 
    cards.forEach(card => { 
      if (card.offsetHeight > maxHeight) { maxHeight = card.offsetHeight; } 
    }); 
    cards.forEach(card => { card.style.height = maxHeight + 'px'; }); }

window.addEventListener('load', equalHeightCards_collection); 
window.addEventListener('resize', equalHeightCards_collection);
